// Packages
import { Routes, Route } from "react-router-dom"

// Screens
import StockListScreen from "modules/Stock/screens/List"
import StockViewScreen from "modules/Stock/screens/View"


const StockRoutes = () => 
{
	return (
		<Routes>
			<Route path="/*" element={<StockListScreen />}/>
			<Route path="/:stockId/*" element={<StockViewScreen />}/>
		</Routes>
	)
}

export default StockRoutes;